/* eslint-disable no-console */

import useApp from "./store/AppState";

// enum SWRegistrationState {
// 	READY,
// 	REGISTERED,
// 	ERROR,
// 	UNKNOWN
// }
const { updateServiceWorker } = useApp()

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    console.log(
      'Registering...'
    )
    navigator.serviceWorker.register(`${process.env.BASE_URL}firebase-messaging-sw.js`)
    .then(async function(registration) {
      if(registration.active?.state === 'activated') {
        console.log('sw is active')
        // notificationsPermisionRequest()
      }
      if (registration.waiting) {
        updateServiceWorker(registration)
      }
      registration.onupdatefound = () => {
        // If updatefound is fired, it means that there's
        // a new service worker being installed.
        var installingWorker = registration.installing;
        if (installingWorker == null) return
        console.log('A new service worker is being installed:',
          installingWorker);
        installingWorker.onstatechange = () => {
          if (installingWorker?.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // prompt to user to reload
              updateServiceWorker(registration)
            }
          }
          // else {
          // }
          if(registration.active?.state === 'activated') {
            console.log('sw is just activated')
          }

        }
        // You can listen for changes to the installing service worker's
        // state via installingWorker.onstatechange
      }
      registration.addEventListener('updatefound', function() {
      });
    })
    .catch(function(error) {
      console.log('Service worker registration failed:', error);
    });
  })
}